__turbopack_context__.v({
  "className": "noto_sans_2bd09725-module__q4hXyG__className",
  "variable": "noto_sans_2bd09725-module__q4hXyG__variable",
});
